import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CForm,CFormInput,CInputGroup,CInputGroupText,CFormSelect,CFormCheck,CButton,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CFormTextarea,
	CBadge,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyDialogpasien,
	MyCardformpasien,
	MyDialoglookup,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc,cBulanPanjang } from '../helpers/functions'
import useSatusehat from '../helpers/useSatusehat'

const pjson 	= require('../../package.json')
const Pasien 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--REDUX_NAV--/
	const { loadToken } 		= useSatusehat(props);
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END REDUX_NAV--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingob 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingob.jml_mobile || 25) : 100;
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") && !uISDemoapp ? true : false;
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;
	const uHandelAdvanced 	= uHeaderActionObj.isHeaderAdvanced || false;

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);
	const [uEfekview2,setEfekview2] 	= React.useState(false);
	const [uSql,setSql] 				= React.useState("SQL");
	const uTokensatusehatObj			= JSON.parse(localStorage.getItem("tokensatusehat")||"{}");
	const [uWilayahObj,setWilayahObj]	= React.useState({});

	const uISManipulate					= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN"||uTokenObj.userhak==="ENTRI") ? true : false;
	const uDatacabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--END VIEWS_VARS--/

	//---FORM_VARS--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});
	const [uDlgPasiensimpan,setDlgPasiensimpan]	= React.useState(false);
	//---END FORM_VARS--/

	//---DLG_PASIEN--/
	const [uIsDlgpasienshow,setDlgpasienshow]= React.useState(false);
	const [uDlgPasienID,setDlgPasienID]		= React.useState(0);
	const uDlgPasiendone		= useSelector(state => state.gInitprosespasien) || false;
	const uDlgPasienObj			= useSelector(state => state.gPasiendetilObj) || {};
	//---END DLG_PASIEN--/

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//---END DLG_LOOKUP--/

	//--DOM_VARS--/
	const uElJmlData			= document.getElementById("idjmldata");
	const uWindowwidth			= window.outerWidth;
	const uISCellphonemode		= uWindowwidth <= 425;
	const uISTabletmode			= uWindowwidth > 425 && uWindowwidth <= 768;
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlToggledlg = () =>{ setDlgformshow(false) }
	const hdlToggleDlgpasien = () =>{ setDlgpasienshow(false) }

	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vIdxObj	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		const vCaptionUpper = (uDatamainArr[vIdxObj].pasien_caption||"").toUpperCase();
		setRowselect(vIdxRow);

		setDlgformObj({...uDlgformObj,
			dlg_jenis: "EDITDATA",
			dlg_header: vCaptionUpper,
			dlg_size: "xl",
			dlg_fullcreen: (uISCellphonemode || uISTabletmode) ? "fullscreen" : "",
		});
		setDlgPasienID(parseInt(uDatamainArr[vIdxObj].id)||0);
		setDlgformshow(true)
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vIdxObj	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		const vCaptionUpper = (uDatamainArr[vIdxObj].pasien_caption||"").toUpperCase();
		setRowselect(vIdxRow);

		if(await(Konfirm("Hapus Data: <B>"+vCaptionUpper+"</B>"+
			"<BR><BR>Apakah Anda Yakin ?"+
			""))) apiProseshapus(_IDTABEL);
	}
	const hdlKlikBatalperiksa = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vIdxObj	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		const vCaptionUpper = (uDatamainArr[vIdxObj].pasien_caption||"").toUpperCase();
		setRowselect(vIdxRow);

		if(await(Konfirm("Batalkan Status Periksa: <B>"+vCaptionUpper+"</B>"+
			"<br/>Apakah Anda Yakin ?"+
			""))) apiProsesbatal(_IDTABEL);
	}
	const hdlKlikLihatdetil = (_IDTABEL) => {
		_IDTABEL	= parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselect(vIdxRow);

		setDlgPasienID(_IDTABEL);
		setDlgpasienshow(true);
	}
	const hdlKlikRekammedis = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;if(_IDTABEL <= 0) return;

		const vTmpObj	= { initID:_IDTABEL, initPage:uPageActive }
		uDispatch({type: "set", gInitTabelSelected: vTmpObj})
		uNavigate("/subpasien/pasien/rekammedis/"+_IDTABEL);
	}
	const hdlKlikFoto = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;if(_IDTABEL <= 0) return;

		const vTmpObj	= { initID:_IDTABEL, initPage:uPageActive }
		uDispatch({type: "set", gInitTabelSelected: vTmpObj})
		uNavigate("/subpasien/pasien/fotopasien/"+_IDTABEL);
	}
	const hdlKlikDaftarantrian = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;if(_IDTABEL <= 0) return;

		const vTmpObj	= { initID:_IDTABEL, initPage:uPageActive }
		uDispatch({type: "set", gInitTabelSelected: vTmpObj})
		uNavigate("/subpasien/pasien/daftarantri/"+_IDTABEL);
	}
	const hdlKlikLihatpiutang = (_IDTABEL) => {}
	const hdlKlikWilayah = (_JENIS) => {//--TIDAK_DIPAKAI--/
		_JENIS = (_JENIS||"").toUpperCase();

		let vDatalookupArr;
		let vCaptionupper;
		if(_JENIS === "PROPINSI") {
			vDatalookupArr = (uWilayahObj.propinsi_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_propinsi||"Propinsi").toUpperCase();
		} else if(_JENIS === "KOTA") {
			if(uDlgformObj.propinsi === undefined) {
				showToast("Nama PROPINSI Harus Dipilih Dahulu !");
				return;
			}

			vDatalookupArr = (uWilayahObj.kota_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_kota||"Kota").toUpperCase();
		} else if(_JENIS === "DISTRIK") {
			if(uDlgformObj.kota === undefined) {
				showToast("Nama KOTA Harus Dipilih Dahulu !");
				return;
			}
			
			vDatalookupArr = (uWilayahObj.distrik_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_distrik||"Distrik").toUpperCase();
		} else if(_JENIS === "VILLAGE") {
			if(uDlgformObj.distrik === undefined) {
				showToast("Nama KECAMATAN Harus Dipilih Dahulu !");
				return;
			}
			
			vDatalookupArr = (uWilayahObj.village_arr || []).map(vItems=>{
				return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
			})
			vCaptionupper = (uBahasaObj.word_village||"Village").toUpperCase();
		}

		if((vDatalookupArr||[]).length > 0) {
			setDlglookupObj({
				jenis: _JENIS,
				data_arr: vDatalookupArr,
				dlg_header: (uBahasaObj.word_lookup||"Lookup")+": "+vCaptionupper,
			});
			setDlglookupshow(true)
			
			return;
		}
		
		const vAccesstoken 		= uTokensatusehatObj.access_token;
 		if(!vAccesstoken) {
 			showToast("<b>Status Token Satusehat BELUM TERKONEKSI</b>.."+
 				"<br/>Mohon Set API KEY dengan Benar, Kemudian Klik GET NEW TOKEN !"+
 			"");return
 		}

		apiLoadwilayah(_JENIS)
	}
	const hdlKlikResetwilayah = async() => {
		const vNextfunction = () => {
			uDlgformObj.propinsi 	= undefined;
			uDlgformObj.kota 		= undefined;
			uDlgformObj.distrik 	= undefined;
			uDlgformObj.village 	= undefined;
			setEfekview(!uEfekview);
		}

		if(uDlgformObj.propinsi === undefined){
			vNextfunction();
			return;
		}

		if(await Konfirm("<b>Data Kewilayahan Alamat Akan Direset</b>.."+
			"<br/>Apakah Anda Yakin ?"+
			"")) vNextfunction();
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {//--TIDAK_DIPAKAI--/
		_IDITEM 		= parseInt(_IDITEM);
		let vArridx;
		let vElfocus;
		if(uDlglookupObj.jenis === "PROPINSI") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.propinsi_arr || []),_IDITEM,"code");
			setDlgformObj({...uDlgformObj,
				propinsi: ((uWilayahObj.propinsi_arr || [])[vArridx] || {}),
				kota: undefined,
				distrik: undefined,
				village: undefined,
			});
			vElfocus 	= document.getElementById("btnkota");

		} else if(uDlglookupObj.jenis === "KOTA") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.kota_arr || []),_IDITEM,"code");
			vElfocus 	= document.getElementById("btndistrik");

			setDlgformObj({...uDlgformObj,
				kota: ((uWilayahObj.kota_arr || [])[vArridx] || {}),
				distrik: undefined,
				village: undefined,
			});
		} else if(uDlglookupObj.jenis === "DISTRIK") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.distrik_arr || []),_IDITEM,"code");
			vElfocus 	= document.getElementById("btnvillage");

			setDlgformObj({...uDlgformObj,
				distrik: ((uWilayahObj.distrik_arr || [])[vArridx] || {}),
				village: undefined,
			});
		} else if(uDlglookupObj.jenis === "VILLAGE") {
			vArridx 	= UFunc.getObjectIndeks((uWilayahObj.village_arr || []),_IDITEM,"code");
			vElfocus 	= document.getElementById("btnDialogSimpan");

			setDlgformObj({...uDlgformObj,
				village: ((uWilayahObj.village_arr || [])[vArridx] || {}),
			});
		}
		setDlglookupshow(false);	

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			if(!isMobile) vElfocus && vElfocus.focus()
		},400)
	}

	const hdlKlikDlgsimpan = () => {
		if(uDlgformObj.dlg_jenis==="EDITDATA") 
			{ setDlgPasiensimpan(true); return; }
		if(uDlgformObj.dlg_jenis==="ADVANCEDSEARCH")
			prosesCariadvanced(); 
	}
	//--END HANDEL--/

	//--INIT--/
	const initFormAwal = () => {
		//console.log("(Pasien - initFormAwal) uDatarole => "+JSON.stringify(uDatarole));
		setIDselect(0)
		setDlgformObj({});
		setDlgPasienID(0);
		setDlgPasiensimpan(false);
	}
	const prosesCariadvanced = () => {
		//alert("uDlgformObj.status_caribulan = "+uDlgformObj.status_caribulan); return;
		//--VALIDASI_DULU--/
		let vElfocus = document.getElementById("inpformnamapasien");
		if((uDlgformObj.nama_pasien||"").trim()===""
			&& (uDlgformObj.telp_hp||"").trim()===""
			&& ((uDlgformObj.status_caribulan||"TIDAK") !== "YA")
			&& (uDlgformObj.propinsi_caption||"").trim()===""
			&& (uDlgformObj.kota_caption||"").trim()===""
			&& (uDlgformObj.distrik_caption||"").trim()===""
			&& (uDlgformObj.village_caption||"").trim()===""
			) {
			vElfocus && vElfocus.focus();
			showToast("Tidak Ada Keyword / Atau Data yang DISET !"); return;
		}
		//--END VALIDASI_DULU--/

		const vKeywordadvancedObj = {
			...uDlgformObj,
			dlg_jenis:undefined,
			dlg_header:undefined,
			dlg_size:undefined,
			dlg_fullcreen: undefined,
		}
		uDispatch({type: "set", clearKeyword: true});
		uKeywordObj.kwd_pasien 		= undefined;
		uKeywordObj.kwd_pasien_adv 	= vKeywordadvancedObj; 
    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));

    	setDlgformObj({...uDlgformObj,status_proses:"YA"});
	}
	//--END INIT--/

	//--CONTENT--/
	const contentKeywordadv = () => {
		if(uHtml500msg) return "";

		const vKeywordadvancedObj = uKeywordObj.kwd_pasien_adv || {};

		return (
		<>
		<div className="d-none">{JSON.stringify(vKeywordadvancedObj)}</div>
		<span className="me-1">&middot;</span>
		{(vKeywordadvancedObj.nama_pasien||"").trim() !== "" && (
		<>
			<span>Kwd Nama:
				<b className="ms-1 text-uppercase">{vKeywordadvancedObj.nama_pasien}</b></span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.status_caribulan === "YA") && (
		<>
			<span>Bln Ultah:
				<b className="ms-1 text-uppercase">{cBulanPanjang[(vKeywordadvancedObj.ultahbulan_id-1)]}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.telp_hp||"").trim() !== "" && (
		<>
			<span>Kwd Telp/HP:
				<b className="ms-1 text-uppercase">{vKeywordadvancedObj.telp_hp}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.alamat||"").trim() !== "" && (
		<>
			<span>Kwd Alamat:
				<b className="ms-1 text-uppercase">{UFunc.renderHTML(vKeywordadvancedObj.alamat)}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.propinsi_caption||"").trim()!=="" && (
		<>
			<span>Prop:
				<b className="ms-1 text-uppercase">{vKeywordadvancedObj.propinsi_caption}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.kota_caption||"").trim()!=="" && (
		<>
			<span>Kota:
				<b className="ms-1 text-uppercase">{vKeywordadvancedObj.kota_caption}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.distrik_caption||"").trim()!=="" && (
		<>
			<span>Kec:
				<b className="ms-1 text-uppercase">{vKeywordadvancedObj.distrik_caption}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}

		{(vKeywordadvancedObj.village_caption||"").trim()!=="" && (
		<>
			<span>Kel:
				<b className="ms-1 text-uppercase">{vKeywordadvancedObj.village_caption}</b>
			</span>
			<span className="mx-1">&middot;</span>
		</>
		)}
		</>
		)//>
	}
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_pasien || "");
		const vKeywordcolor = uSettingob.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		/*const vDataviewArr	= isMobile 
			? uDatamainArr.slice(0,(vMax+1)) : uDatamainArr.slice(vMin,(vMax+1));//--*/
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.page||1) === parseInt(uPageActive));
		
		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={35} className="px-1">No</th>
			<th className="px-1">
			<CRow className="mx-0">
			<CCol md="4" lg="5" className="text-start">{uBahasaObj.caption_namapasien||"Nama Pasien"}</CCol>
			<CCol md="3" lg="2" className="">&middot;</CCol>
			<CCol md="1" className="">{uBahasaObj.word_umur||"Umur"}</CCol>
			<CCol md="4" className="text-start">{uBahasaObj.word_keterangan||"Keterangan"}</CCol>
			</CRow>
			</th>
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,tgl_input,userinput,pasien_caption,panggilan,
				telp_hp,alamat,umur,init_process,status_periksa,sex,
				status_piutang,cabang_register,nomor_rm,ihs_number,nik
			} = vItems;

			vNumber++;
			const vCaptionUpper	= (pasien_caption||"").toUpperCase();

			const vPasiencaption	= vKeyword==="" ? (pasien_caption||"UNDF") 
				: (pasien_caption||"UNDF").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vPanggilan	= vKeyword==="" ? (panggilan||"") 
				: (panggilan||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vNomorRM	= vKeyword==="" ? (nomor_rm||"") 
				: (nomor_rm||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vTelphp	= vKeyword==="" ? (telp_hp||"") 
				: (telp_hp||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vNIK	= vKeyword==="" ? (nik||"-") 
				: (nik||"-").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vIHSnumber	= vKeyword==="" ? (ihs_number||"") 
				: (ihs_number||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vCabangregister	= (cabang_register||"UNDF");
			const vAlamat	= vKeyword==="" ? (alamat||"") 
				: (alamat||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTglInput	= vKeyword==="" ? UFunc.TglAngkaDT(tgl_input||"") 
				: UFunc.TglAngkaDT(tgl_input||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vUserinput	= UFunc.Usercaptionfilter((userinput||"UNDF"),1);

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}>
				<td className="px-1 pe-0">{vNumber}.</td>

				<td className="px-1">
				<CRow className="mx-0">
				<CCol md="4" lg="5" className="px-1 text-start">
					<div className="d-flex justify-content-between">
						<div>
						<span className="text-capitalize text-info">{UFunc.renderHTML(vPasiencaption)}</span>
						{(nomor_rm||"")!=="" && (
						<span className="d-none classfontsmaller"> &middot; (<small className="fw-bolder">{UFunc.renderHTML(vNomorRM)}</small>)</span>
						)}
						</div>

						<div
							style={{color:((sex||"")==="P"?"pink":"navy")}} 
							className="fw-bolder d-none d-md-block ps-1">[{sex||"L"}]</div>
						
						{(init_process||false)===true ? (
							<CSpinner className="d-md-none" color="warning" size="sm"/>
						) : (
						<div className="d-md-none">
						{(uISManipulate) && (status_periksa||"TIDAK")==="YA" && (
						<>
							<CLink onClick={()=>hdlKlikBatalperiksa(id)}>
							<CImage src={pjson.homepage+"api/images/icon_periksabatal.png"}
								className="align-middle me-1" height={25}/>
							</CLink>
						</>
						)}

						<CDropdown>
						<CDropdownToggle caret={false} size="sm"
							className="p-0" color="transparent">
							<CIcon icon="cilOptions" height={18}/>
						</CDropdownToggle>
						<CDropdownMenu>
							{(uISManipulate) && (
							<CDropdownItem onClick={()=>hdlKlikDaftarantrian(id)} className="classcursorpointer">
								<CImage src={pjson.homepage+"api/images/icon_booking.png"} className="ms-0 me-2 align-middle" height={25}/>
								Booking Reservasi
							</CDropdownItem>
							)}

							{uTokenObj.userhak!== "ENTRI" && (
							<CDropdownItem onClick={()=>hdlKlikRekammedis(id)} className="classcursorpointer">
								<CImage src={pjson.homepage+"api/images/icon_rekammedis.png"} className="ms-0 me-2 align-middle" height={25}/>
								Rekam Medis Pasien
							</CDropdownItem>
							)}

							<CDropdownItem onClick={()=>hdlKlikLihatdetil(id)}>
								<CIcon icon="cilFindInPage" className="classikonbox ms-0 me-2" height={25}/>
								{uBahasaObj.caption_viewdetil||"Lihat Detil Pasien"}
							</CDropdownItem>

							<CDropdownItem onClick={()=>hdlKlikFoto(id)} className="classcursorpointer">
								<CImage src={pjson.homepage+"api/images/icon_foto.png"} className="ms-0 me-2 align-middle" height={25}/>
								Foto Pasien
							</CDropdownItem>

							{(uISManipulate || (uIsHapusallow||false)===true) && (
								<CDropdownDivider/>
							)}

							{(uISManipulate) && (
							<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
								<CIcon className="classikonedit me-2 align-middle" height={25}/>
								{uBahasaObj.caption_editdata||"Edit Data"}
							</CDropdownItem>
							)}
							
							{(uIsHapusallow||false)===true && (
							<>
							<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
								<CIcon className="classikonhapus me-2 align-middle" height={25}/>
								{uBahasaObj.caption_hapusdata||"Hapus Data"}
							</CDropdownItem>
							</>
							)}
						</CDropdownMenu>
						</CDropdown>
						</div>
						)}
					</div>

					<small className="d-none d-md-block">
						<span className="me-1">&middot;</span>
						{uDatacabangArr.length > 1 && (
						<>
						<span className="text-primary">{UFunc.renderHTML(vCabangregister)}</span>
						<span className="mx-1">&middot;</span>
						</>
						)}
						<span className="text-success classfontsmaller">
							IHS:<b className="ms-1">
							{(ihs_number||"")!=="" ? (
							<>{UFunc.renderHTML(vIHSnumber)}</>
							) : (
							<CIcon icon="cilXCircle" height={15}/>							
							)}
							</b>
						</span>
						<span className="ms-1">&middot;</span>
					</small>

					<span className="text-danger d-none d-md-block classfontsmaller">
						<small>
						[{UFunc.renderHTML(vTglInput)}
						<span className="mx-1">&middot;</span>
						{UFunc.renderHTML(vUserinput)}]
						</small>
					</span>
				</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol md="3" lg="2" className="px-0 text-md-center d-none d-md-block">
					{(init_process||false)===true ? (
						<CSpinner color="warning" size="sm"/>
					) : (
					<>
					{(uISManipulate) && (status_periksa||"TIDAK")==="YA" && (
						<CTooltip content={"--Batalkan Periksa: "+vCaptionUpper}>
						<CLink 
							onClick={()=>hdlKlikBatalperiksa(id)}
							className="classcursorpointer">
							<CImage src={pjson.homepage+"api/images/icon_periksabatal.png"}
								className="me-2" height={32}/>
						</CLink>
						</CTooltip>
					)}

					{uTokenObj.userhak!== "ENTRI" && (
					<CTooltip content={"--"+(uBahasaObj.caption_rekammedis||"Rekam Medis")+": "+vCaptionUpper}>
					<CLink onClick={()=>hdlKlikRekammedis(id)} className="classcursorpointer">
						<CImage src={pjson.homepage+"api/images/icon_rekammedis.png"} className="me-1" height={27}/>
					</CLink>
					</CTooltip>
					)}

					{(uISManipulate) && (
					<CTooltip content={"--"+(uBahasaObj.caption_bookingreservasi||"Booking Reservasi")+": "+vCaptionUpper}>
					<CLink onClick={()=>hdlKlikDaftarantrian(id)} className="classcursorpointer">
						<CImage src={pjson.homepage+"api/images/icon_booking.png"} className="mx-1" height={27}/>
					</CLink>
					</CTooltip>
					)}
						
					<CDropdown>
					<CDropdownToggle caret={false} size="sm"
						className="p-0" 
						color="transparent">
						<CIcon icon="cilChevronBottom" className="classikonbox" height={25}/>
					</CDropdownToggle>
					<CDropdownMenu>
						<CDropdownItem onClick={()=>hdlKlikLihatdetil(id)} className="classcursorpointer">
							<CIcon icon="cilFindInPage" className="classikonbox ms-0 me-2" height={27}/>
							{uBahasaObj.caption_viewdetil||"Lihat Detil"}
						</CDropdownItem>

						<CDropdownItem onClick={()=>hdlKlikFoto(id)} className="classcursorpointer">
							<CImage src={pjson.homepage+"api/images/icon_foto.png"} className="ms-0 me-2 align-middle" height={25}/>
							Foto Pasien
						</CDropdownItem>

						{(uISManipulate || (uIsHapusallow||false)===true) && (
							<CDropdownDivider/>
						)}

						{(uISManipulate) && (
						<CDropdownItem onClick={()=>hdlKlikEdit(id)} className="classcursorpointer">
							<CIcon className="classikonedit align-middle me-2" height={27}/>
							{uBahasaObj.caption_editdata||"Edit Data"}
						</CDropdownItem>
						)}
							
						{(uIsHapusallow||false)===true && (
						<>
						<CDropdownItem onClick={()=>hdlKlikHapus(id)} className="classcursorpointer">
							<CIcon className="classikonhapus align-middle me-2" height={27}/>
							{uBahasaObj.caption_hapusdata||"Hapus Data"}
						</CDropdownItem>
						</>
						)}
					</CDropdownMenu>
					</CDropdown>
					</>
					)}
				</CCol>

				<CCol xs="5" className="px-1 d-none text-start">{uBahasaObj.caption_norm||"No.RM"}</CCol>
				<CCol xs="7" className="px-1 d-none">
					<small className="fw-bolder">{UFunc.renderHTML(vNomorRM)}</small>
				</CCol>

				<CCol xs="5" className="px-1 d-md-none text-start">NIK</CCol>
				<CCol xs="7" className="px-1 d-md-none">
					<b>{UFunc.renderHTML(vNIK)}</b>
				</CCol>

				<CCol xs="5" className="px-1 d-md-none text-start">IHS Number</CCol>
				<CCol xs="7" className="px-1 d-md-none text-success">
					{(ihs_number||"")!=="" ? (
					<>{UFunc.renderHTML(vIHSnumber)}</>
					) : (
					<CIcon icon="cilXCircle" height={20}/>							
					)}
				</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="5" className="px-1 d-md-none text-start">{uBahasaObj.word_sex||"Gender"}</CCol>
				<CCol xs="7" md="1" className="px-1 d-md-none">
					<b style={{color:((sex||"")==="P"?"pink":"navy")}} >
					[ {(sex||"L")} ]
					</b> 
				</CCol>

				<CCol xs="5" className="px-1 d-md-none text-start">{uBahasaObj.word_umur||"Umur"}</CCol>
				<CCol xs="7" md="1" className="px-1 text-md-center">
					<small className="fw-bolder">{(umur||"-")}</small>
				</CCol>

				<CCol xs="4" className="px-1 d-md-none text-start">{uBahasaObj.word_alamat||"Alamat"}</CCol>
				<CCol xs="8" md="4" className="px-1 text-md-start">
					{(((alamat||"")==="" || (alamat||"")==="-") 
						&& ((telp_hp||"")==="" || (telp_hp||"")==="-") 
						&& ((ihs_number||"")==="" || (telp_hp||"")==="-") 
						&& (status_piutang||"TIDAK")==="TIDAK"
					) ? ("-") : (
					<>
						{1===3 && (
						<>
						{(status_piutang||"TIDAK")==="YA" && (
						<div className="">
							<CLink
								onClick={()=>hdlKlikLihatpiutang(id)}
								className="classcursorpointer">
							<CBadge color="danger" className="classblinking">&middot; ADA HUTANG &middot;</CBadge>
							</CLink>
						</div>
						)}
						</>
						)}

						{(nik||"")!=="" && (
						<div className="d-none d-md-block">NIK: <b className="">{UFunc.renderHTML(vNIK)}</b></div>
						)}

						{(alamat||"")!=="" && (
						<small className="fst-italic">{UFunc.renderHTML(vAlamat)}</small>
						)}

						{(telp_hp||"")!=="" && (uTokenObj.userhak !== "DOKTER") && (
						<div className="d-none d-md-block">Telp/HP. <b className="text-primary">{UFunc.renderHTML(vTelphp)}</b></div>
						)}
					</>
					)}
				</CCol>

				{(telp_hp||"")!=="" && (uTokenObj.userhak !== "DOKTER") && (
				<>
				<CCol xs="5" className="px-1 d-md-none text-start">Telp/HP</CCol>
				<CCol xs="7" className="px-1 text-primary d-md-none">
					<b>{UFunc.renderHTML(vTelphp)}</b>
				</CCol>
				</>
				)}

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>
				{uDatacabangArr.length > 1 && (
				<>
				<CCol xs="5" className="px-1 d-md-none text-start">
					<small>Cabang Register</small>
				</CCol>
				<CCol xs="7" className="px-1 text-primary d-md-none">
					<small>&middot;{UFunc.renderHTML(vCabangregister)}&middot;</small>
				</CCol>
				</>
				)}

				<CCol xs="4" className="px-1 d-md-none text-start">
					<>{uBahasaObj.caption_inputby||"Inputby"}</>
				</CCol>
				<CCol xs="8" className="px-1 text-danger d-md-none classfontsmaller">
					<small>[{UFunc.renderHTML(vTglInput)} &middot; {UFunc.renderHTML(vUserinput)}]</small>
				</CCol>

				{(status_piutang||"TIDAK")==="YA" && (
				<>
				<CCol xs="12" className="px-1 my-2 d-md-none classborderbottom"/>
				<CCol xs="12" className="px-1 d-md-none text-center">
					<CLink
						onClick={()=>hdlKlikLihatpiutang(id)}
						className="classcursorpointer">
					<CBadge color="danger" className="classblinking">&middot; ADA HUTANG &middot;</CBadge>
					</CLink>
				</CCol>
				</>
				)}
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//->
		if(uDlgformObj.dlg_jenis==="EDITDATA") return (<>{contentEditpasien()}</>)//>
		if(uDlgformObj.dlg_jenis==="ADVANCEDSEARCH") return (<>{contentAdvsearch()}</>)//>

		return (<></>)//>
	}
	const contentEditpasien = () => {
		if(uDlgformObj.dlg_jenis!=="EDITDATA") return (<></>)//->
		
		return (
			<MyCardformpasien 
				pasienID={uDlgPasienID}
				showButton={false}
				simpanKlik={uDlgPasiensimpan}
				{...props}/>
		)
	}
	const contentAdvsearch = () => {
		if(uDlgformObj.dlg_jenis!=="ADVANCEDSEARCH") return (<></>)//->

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">Nama Pasien</CCol>
			<CCol>
				<CFormInput size="sm" 
					placeholder="--Masukkan Keyword Nama Pasien"
					value={uDlgformObj.nama_pasien||""}
					onChange={(e)=>setDlgformObj({...uDlgformObj,nama_pasien:e.target.value})}
					id="inpformnamapasien"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">
				Bulan Lahir<span className="ms-1 d-none d-md-inline">Pasien</span>
			</CCol>
			<CCol xs="8" lg="5">
				<CInputGroup size="sm">
				<CInputGroupText className="border-0 bg-transparent">
				<input type="checkbox" 
					checked={uDlgformObj.status_caribulan==="YA"}
					onChange={(e)=>{
						setDlgformObj({...uDlgformObj,
							status_caribulan: e.target.checked?e.target.value:undefined,
						});
					}}
					value="YA"					
					id="chbformbulanlahir"/>
				</CInputGroupText>
				<CFormSelect size="sm"
					disabled={uDlgformObj.status_caribulan!=="YA"}
					value={uDlgformObj.ultahbulan_id}
					onChange={(e)=>setDlgformObj({...uDlgformObj,ultahbulan_id:e.target.value})}
					id="inpformbulanlahir">
				{cBulanPanjang.map((vItems,vKeys)=>{
					return (
					<option value={(vKeys+1)} key={vKeys}>{vItems.toUpperCase()}</option>
					)
				})}
				</CFormSelect>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">
				Wilayah<span className="ms-1 d-none d-md-inline">Administrasi</span>
			</CCol>

			<CCol xs="8" lg="5">
			<CFormInput size="sm"
				placeholder="--Masukkan Keyword PROPINSI"
				value={uDlgformObj.propinsi_caption||""}
				onChange={(e)=>setDlgformObj({...uDlgformObj,propinsi_caption:e.target.value})}
				id="inppropinsi"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">&nbsp;</CCol>

			<CCol xs="8" lg="5">
			<CFormInput size="sm"
				placeholder="--Masukkan Keyword KOTA"
				value={uDlgformObj.kota_caption||""}
				onChange={(e)=>setDlgformObj({...uDlgformObj,kota_caption:e.target.value})}
				id="inpkota"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">&nbsp;</CCol>

			<CCol xs="8" lg="5">
			<CFormInput size="sm"
				placeholder="--Masukkan Keyword KECAMATAN"
				value={uDlgformObj.distrik_caption||""}
				onChange={(e)=>setDlgformObj({...uDlgformObj,distrik_caption:e.target.value})}
				id="inpdistrik"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">&nbsp;</CCol>

			<CCol xs="8" lg="5">
			<CFormInput size="sm"
				placeholder="--Masukkan Keyword DESA"
				value={uDlgformObj.village_caption||""}
				onChange={(e)=>setDlgformObj({...uDlgformObj,village_caption:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpvillage"/>
			</CCol>
		</CRow>

		{1===3 && (//--TIDAK_DIPAKAI--/
		<>
		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">Telp/HP</CCol>
			<CCol>
				<CFormInput size="sm" 
					placeholder="--Masukkan Keyword Telp-HP Pasien"
					value={uDlgformObj.telp_hp||""}
					onChange={(e)=>setDlgformObj({...uDlgformObj,telp_hp:e.target.value})}
					id="inpformtelepon"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">Alamat</CCol>
			<CCol>
				<CFormInput size="sm" 
					placeholder="--Masukkan Keyword Alamat Pasien"
					value={uDlgformObj.alamat||""}
					onChange={(e)=>setDlgformObj({...uDlgformObj,alamat:e.target.value})}
					id="inpformtelepon"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="4" className="classfontsmaller pe-0">
				Wilayah<span className="ms-1 d-none d-md-inline">Administrasi</span>
			</CCol>

			<CCol>
				<div className="d-grid gap-2 gap-md-1 d-md-block d-lg-inline-block me-lg-1">
				<CTooltip className="d-none d-lg-block" content="--Reset Kewilayahan Alamat..">
				<CLink onClick={()=>hdlKlikResetwilayah()} className="classcursorpointer d-none d-md-inline">
					<CIcon icon="cilSync" className="classikonbox align-middle mx-0 me-1" height={23}/>
				</CLink>
				</CTooltip>

				<CButton size="sm" color="dark" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("PROPINSI")}
					id="btnpropinsi">
				{uDlgformObj.propinsi===undefined ? (
					<small>Pilih Propinsi</small>
				) : (
					<small className="fw-bolder">{(uDlgformObj.propinsi.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>

				<span className="ms-1 d-none d-md-inline"/>

				<CButton size="sm" color="primary" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("KOTA")}
					id="btnkota">
				{uDlgformObj.kota===undefined ? (
					<small>Pilih Kota</small>
				) : (
					<small className="fw-bolder">{(uDlgformObj.kota.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>

				</div>
				<div className="d-grid gap-2 gap-md-1 d-md-block d-lg-inline-block mt-2">

				<CButton size="sm" color="warning" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("DISTRIK")}
					id="btndistrik">
				{uDlgformObj.distrik===undefined ? (
					<small>Pilih Kecamatan</small>
				) : (
					<small className="fw-bolder">{(uDlgformObj.distrik.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>

				<span className="ms-1 d-none d-md-inline"/>

				<CButton size="sm" color="success" variant="outline" className="px-2" 
					onClick={()=>hdlKlikWilayah("VILLAGE")}
					id="btnvillage">
				{uDlgformObj.village===undefined ? (
					<small>Pilih Desa/Kelurahan</small>
				) : (
					<small className="fw-bolder">{(uDlgformObj.village.name||"").toUpperCase()}</small>
				)}
				<CIcon icon="cilSearch" className="ms-1"/>
				</CButton>
				</div>
			</CCol>
		</CRow>
		</>
		)}
		</CForm>	
		)//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoaddata = (_PAGE) => {
		_PAGE	= parseInt(_PAGE)||1;
		setHtml500msg();

		const vKeyword 				= uKeywordObj.kwd_pasien || "";
		const vKeywordadvancedObj 	= uKeywordObj.kwd_pasien_adv || {};

		let vDatamainArr	= uDatamainArr;
		if(vKeyword.length < 3) {
			vDatamainArr 	= []
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) === 1);
			} else
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) !== uPageActive);
		}
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_keywordadv : JSON.stringify(vKeywordadvancedObj),
			send_page: _PAGE,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}") ? "YA" : "TIDAK",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				//setSql((output_string.sql||"--EMPTY--"))
				const vTmpObj = JSON.parse(output_string.dataobject||"[]");
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.total_data||uJmlData))
				else setJmlData(vTmpObj.length);

				setDatamainArr([...vDatamainArr,...vTmpObj]);
				//console.log("(Pasien - apiLoaddata) uPageActive : "+(uPageActive));
		    	if(JSON.stringify(uLastinitObj||{}) !== "{}") 
		    		setInitselectedObj(uLastinitObj);

				const vTimeEnd = new Date(); 
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Pasien - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Pasien - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		const vIdxObj	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		setLoading(true)

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/pr_hapus";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setLoading(false);
			if(output_string.sukses) {
				uDatamainArr.splice(vIdxObj,1);
				setRowselect(-1);
				setJmlData((parseInt(uDatamainArr.length)||0));
			
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Pasien - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Pasien - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesbatal = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;
		if(_IDTABEL <= 0) return;

		const vIdxObj	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		uDatamainArr[vIdxObj].init_process = true
		setEfekview(!uEfekview)

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_pasienid : _IDTABEL,
			send_reloaddata: "TIDAK",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_rekammedis/pr_periksabatal";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); } })
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			uDatamainArr[vIdxObj].init_process = false
			if(output_string.sukses) {
				uDatamainArr[vIdxObj].status_periksa = "TIDAK"
				setEfekview2(!uEfekview2);
			} else {
				setEfekview2(!uEfekview2)
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Pasien - apiProsesbatal) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			uDatamainArr[vIdxObj].init_process = false
			setEfekview2(!uEfekview2);
			console.log("(Pasien - apiProsesbatal) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiLoadwilayah = (_JENIS) => {//--TIDAK_DIPAKAI--/
		_JENIS = (_JENIS||"").toUpperCase();
		//const vTokensatusehatObj= JSON.parse(localStorage.getItem("tokensatusehat")||"{}");
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		const vNextfunction 	= () => apiLoadwilayah(_JENIS);
		
 		if(!vAccesstoken) {
 			loadToken(vNextfunction); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadToken(vNextfunction); return;
		}

		let vElbutton;
		let vURLwilayah;
		let vDataObj	 = {
			send_accesstoken : vAccesstoken,
			send_tokenauth : uTokenObj.userinit
		}
		if(_JENIS === "PROPINSI") {
			vElbutton 	= document.getElementById("btnpropinsi");
			vURLwilayah	= pjson.homepage+"api/api_init/ld_propinsi";
		} else if(_JENIS === "KOTA") {
			vElbutton 	= document.getElementById("btnkota");
			vDataObj	= {...vDataObj,
				send_kodepropinsi : (uDlgformObj.propinsi||{}).code || "0"
			}
			vURLwilayah	= pjson.homepage+"api/api_init/ld_kota";
		} else if(_JENIS === "DISTRIK") {
			vElbutton 	= document.getElementById("btndistrik");
			vDataObj	= {...vDataObj,
				send_kodekota : uDlgformObj.kota.code || "0",
			}
			vURLwilayah	= pjson.homepage+"api/api_init/ld_distrik";
		} else if(_JENIS === "VILLAGE") {
			vElbutton 	= document.getElementById("btnvillage");
			vDataObj	= {...vDataObj,
				send_kodedistrik : uDlgformObj.distrik.code || "0",
			}
			vURLwilayah	= pjson.homepage+"api/api_init/ld_village";
		}
		vElbutton && (vElbutton.disabled = true);
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return;//--*/

		const vDATAS	= JSON.stringify(vDataObj);
		const vURLs	= vURLwilayah;

		const vTimeBegin = new Date();
		fetch(vURLs,{
			method: "POST",
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Pasien - apiLoadwilayah) output_string.datakota => "+output_string.datakota)
				let vTmpArr;
				if(_JENIS === "PROPINSI") {
				 	vTmpArr	= JSON.parse(output_string.datapropinsi || "[]");
					uWilayahObj.propinsi_arr = vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_propinsi||"Provinsi").toUpperCase();
				} else if(_JENIS === "KOTA") {
				 	vTmpArr	= JSON.parse(output_string.datakota || "[]");
					uWilayahObj.kota_arr 	= vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_kota||"Kota").toUpperCase();
				} else if(_JENIS === "DISTRIK") {
				 	vTmpArr	= JSON.parse(output_string.datadistrik || "[]");
					uWilayahObj.distrik_arr	= vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_distrik||"Distrik").toUpperCase();
				} else if(_JENIS === "VILLAGE") {
				 	vTmpArr	= JSON.parse(output_string.datavillage || "[]");
					uWilayahObj.village_arr	= vTmpArr;
					uDlglookupObj.headers	= (uBahasaObj.word_lookup||"Lookup")+": "+
						(uBahasaObj.word_village||"Village").toUpperCase();
				}

				const vDatalookupArr = (vTmpArr||[]).map(vItems=>{
					return {id:vItems.code,caption:(vItems.name||"").toUpperCase()}
				})
				uDlglookupObj.jenis			= _JENIS;
				uDlglookupObj.data_arr		= vDatalookupArr;
				
				setDlglookupshow(true)
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Pasien - apiLoadwilayah) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Pasien - apiLoadwilayah) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		uDispatch({type: "set", gBillingperiksaObj: undefined});

    	//const vPageinit	= uPageActive;
		//console.log("(Pasien - []) uLastinitObj.initPage => "+(uLastinitObj.initPage))
		if(JSON.stringify(uLastinitObj||{}) !== "{}") {
			setPageActive(uLastinitObj.initPage||1);
			apiLoaddata(uLastinitObj.initPage||1);
		}

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
    		setDatamainArr([]);
    		setInitselectedObj({});
    		uDispatch({type: "set", gInitprosespasien: undefined});
			uDispatch({type: "set", gPasiendetilObj: undefined});
			setDlgformshow(false);
			setPageActive(0);
    	}
	},[])
	React.useEffect(()=>{ 
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		setRowselect(-1); 
		const vDataviewArr	= uDatamainArr.filter(vItems=>parseInt(vItems.page||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoaddata(uPageActive);
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{ 
		if(!uElJmlData) return;

		const vKeyword 		= uKeywordObj.kwd_pasien || "";
		if(vKeyword.length < 3) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uElJmlData])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/

		const vKeyword 		= uKeywordObj.kwd_pasien || "";
		if(vKeyword.length < 3) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData])
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		//setElJmlData(null);
		setHtml500msg();
		setDatamainArr([]);
		setJmlData(0);
		setIDselect(0);
		setRowselect(-1);

		//console.log("(Pasien - [uHandelView]) uHandelView => "+uHandelView)
		if(parseInt(uPageActive) !== 1) {
			setPageActive(1);
		} else apiLoaddata();
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

		uNavigate("/subpasien/pasieninput");
		//uDlgformObj.dlg_header = ((uBahasaObj.word_tambah||"Tambah")+" "+uBahasaObj["menus_"+uActiveroute.toLowerCase()]);
		//setDlgformshow(true)
	},[uHandelTambah])
	React.useEffect(()=>{
		if(!uHandelAdvanced) return;

		uHeaderActionObj.isHeaderAdvanced = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;
		
		//--LOAD_FORM_ADVANCED--/
		const vKeywordadvancedObj = uKeywordObj.kwd_pasien_adv || {};
		setDlgformObj({...uDlgformObj,
			dlg_jenis: "ADVANCEDSEARCH",
			dlg_header: "Pencarian Tingkat Lanjut",
			dlg_size: "lg",
			nama_pasien: vKeywordadvancedObj.nama_pasien,
			telp_hp: vKeywordadvancedObj.telp_hp,
			status_caribulan: vKeywordadvancedObj.status_caribulan,
			ultahbulan_id: vKeywordadvancedObj.ultahbulan_id || ((new Date()).getMonth()+1),
			alamat: vKeywordadvancedObj.alamat,
			propinsi_caption: vKeywordadvancedObj.propinsi_caption,
			kota_caption: vKeywordadvancedObj.kota_caption,
			distrik_caption: vKeywordadvancedObj.distrik_caption,
			village_caption: vKeywordadvancedObj.village_caption,
		});
		setDlgformshow(true)
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);
			document.getElementById("btnDialogSimpan") &&
				(document.getElementById("btnDialogSimpan").innerHTML = "Cari");
		},300);
		//--END LOAD_FORM_ADVANCED--/
	},[uHandelAdvanced])
	React.useEffect(()=>{
		uDispatch({type: "set", gInitTabelSelected: {}});
		if(JSON.stringify(uInitselectedObj||{}) === "{}") return;

		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+(uInitselectedObj.initID||0));
		setRowselect(vIdxRow);
		
		const vElscroll	= document.getElementById("idtr"+(uInitselectedObj.initID||0));
		const vRectdimensi = vElscroll && (vElscroll.getBoundingClientRect());
		vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		//console.log("(Pasien - [uInitselectedObj]) vRectdimensi => "+JSON.stringify(vRectdimensi))

		setInitselectedObj({});
	},[uInitselectedObj])
	React.useEffect(()=>{
		if(!uISDlgformshow) { initFormAwal(); return; }

		//console.log("("+cComponentName+"[uISDlgformshow]) uISDlgformshow 1: "+uISDlgformshow);
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);

			let vElfocus = document.getElementById("inpformnamapasien");
			if(!isMobile) vElfocus && vElfocus.focus();
		},200);
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(!uISDlglookupshow)
			{ setDlglookupObj({}); return }
	},[uISDlglookupshow])
	React.useEffect(()=>{
		if(!uDlgformObj.status_proses) return;
		if(uDlgformObj.status_proses!=="YA") return;

		setDlgformshow(false);
		apiLoaddata();
	},[uDlgformObj.status_proses])
	React.useEffect(()=>{
		if(uDlgPasiensimpan) {
			setDlgPasiensimpan(false);
			return 
		}
	},[uDlgPasiensimpan])
	React.useEffect(()=>{
		if(JSON.stringify(uDlgPasienObj)==="{}") return;
		if(parseInt(uIDselect) <= 0) return;

		//console.log("Pasien - [uDlgPasienObj]) uDlgPasienObj => "+JSON.stringify(uDlgPasienObj));
		const vIdxObj	= UFunc.getObjectIndeks(uDatamainArr,uIDselect)

		uDatamainArr[vIdxObj].pasien_caption	= uDlgPasienObj.pasien_caption||"";
		uDatamainArr[vIdxObj].panggilan	= uDlgPasienObj.panggilan||"";
		uDatamainArr[vIdxObj].telp_hp	= uDlgPasienObj.telp_hp||"";
		uDatamainArr[vIdxObj].alamat	= uDlgPasienObj.alamat||"";
		uDatamainArr[vIdxObj].umur		= uDlgPasienObj.umur||"";
		uDatamainArr[vIdxObj].sex 		= uDlgPasienObj.sex||"";

		uDatamainArr[vIdxObj].nik 		= uDlgPasienObj.nik||"";
		uDatamainArr[vIdxObj].ihs_number= uDlgPasienObj.ihs_number||"";
	},[uDlgPasienObj])
	React.useEffect(()=>{
		if(uDlgPasiendone) {
    		uDispatch({type: "set", gInitprosespasien: false});
			uDispatch({type: "set", gPasiendetilObj: {}});
			hdlToggledlg(); return;
		}
	},[uDlgPasiendone])
	//console.log("Pasien - uPageActive => "+JSON.stringify(uPageActive));

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<b>{uBahasaObj.caption_page500||"Page 500"}</b>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-start">
		<div>
			<b className="align-middle">{uBahasaObj.caption_listdata||"List Data"}</b>
			<span className="mx-1 d-md-none">&middot;</span>
			<small className="d-md-none text-primary align-middle">{(()=>{
				const vKeyword = (uKeywordObj.kwd_pasien||"").trim();
				if(vKeyword.length < 3) return (<>&#8734;</>);

				return (<>[{UFunc.formatAngka(uJmlData)}]</>)
			})()}</small>

			{uKeywordObj.kwd_pasien_adv && (
				<div style={{color:"maroon"}} className="fst-italic classfontsmaller">
				<small>{contentKeywordadv()}</small>
				</div>
			)}
			<div>{uHtml500msg}</div>
		</div>

		<span className="text-muted classfontsmaller">
			<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
		</span>
		</CCardHeader>
		
		<CCardBody className="px-0">{contentMain()}</CCardBody>

		{(uJmlData > uMaxData) && (
		<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/> 
		</CCardFooter>
		)}
		</CCard>

		<MyDialogform
			options={{size:(uDlgformObj.dlg_size),fullscreen:uDlgformObj.dlg_fullcreen}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.dlg_header}
			toggle={hdlToggledlg}
			renderContent={contentDlgform()}/>

		<MyDialogpasien show={uIsDlgpasienshow}
			pasienID={uDlgPasienID}
			toggle={hdlToggleDlgpasien}
			{...props}/>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>
		</>
	)//>
}	

export default Pasien